import "./model.css";
import React, { useEffect, useState, Suspense } from "react";
import ReactGA from "react-ga";
import { Canvas, useThree, useFrame } from "@react-three/fiber";
import {
  Environment,
  OrbitControls,
  Html,
  useProgress,
  useGLTF,
  useTexture,
} from "@react-three/drei";
import * as THREE from "three";
import { useDispatch, useSelector } from "react-redux";
import { setHotspotClick } from "../../redux/actions/hotspot-click-action";
import ProgressBar from "../../components/elements/progressbar";
import { setDefaultModel } from "../../redux/actions/default-model-action";
import Loader from "../../components/loader";
import { BaseUrl } from "../../config.js";
import detect from "detect.js";
let executeOnce = false,
  isModelLoaded,
  isDefaultColorSet = false,
  isAutoRotate,
  skyboxUrl,
  hdrUrl,
  modelUrl,
  shadowUrl,
  curLayoutData,
  meshesHotspot,
  meshesConfig,
  userSelectedKitId,
  mixer,
  progCount,
  progText,
  ghostedMeshes = [];
const backgroundColorCode = 0xffffff;
const enum_AnimStaus = {
  Play: "true",
  Pause: "false",
  Loop: "loop",
  Reverse: "playreverse",
};

const tenantBaseUri = "Tenant_tvsmotor/Assets/";

const Model = React.memo(function Model({ pid }) {
  progCount = 50;
  // console.log("Model Start ", progCount);
  let skyboxTex;
  const [modelTarget, setTarget] = useState(null);
  const mahindraHardCode = "MHEL";
  const RR310 = "RR310";
  const RTR310Launch = "RTR310Launch";
  const RTR310HardCode = "RTR-310";

  modelUrl = BaseUrl() + pid + "/" + pid + ".glb";
  hdrUrl = BaseUrl() + pid + "/envi.hdr";
  shadowUrl = BaseUrl() + pid + "/shadow.png";
  skyboxUrl = BaseUrl() + pid + "/bgTvs.png";
  const gltf = useGLTF(modelUrl);
  useGLTF.preload(modelUrl);

  const [loaded, setLoaded] = useState(false);
  const [meshPoints, setMeshPoints] = useState([]);
  const [meshVisibility, setMeshVisibility] = useState(false);
  // const [nodeList, setNodeList] = useState([]);
  const onColorChange = useSelector((state) => state.color.color);
  const onUIAnnotation = useSelector((state) => state.hotspot.status);
  const hotspotPanelClose = useSelector((state) => state.hotspotClose.status);
  const layoutData = useSelector((state) => state.meshData.data);
  const hotspotdata = useSelector((state) => state.hotspotData.data);

  const customCompId = useSelector((state) => state.customCompId.id);
  const customConfigData = useSelector((state) => state.customConfigData.data);
  const reset = useSelector((state) => state.reset.status);
  const menuStatus = useSelector((state) => state.menuStatus.status);
  const animation = useSelector((state) => state.animation.status);
  const rotate = useSelector((state) => state.rotate.status);
  const layoutMap = useSelector((state) => state.layoutMap.data);
  const raceNum = useSelector((state) => state.raceNum.num);
  const [selectedConfigs, setSelectedConfig] = useState([]);
  const [curLayout, setCurLayout] = useState([]);
  const dispatch = useDispatch();

  function DeviceCheck() {
    const userAgentString = navigator.userAgent;
    const parsedDeviceInfo = detect.parse(userAgentString);

    //console.log('parsedDeviceInfo', parsedDeviceInfo)
    const isiPhone = parsedDeviceInfo.device.family === "iPhone";
    const isAndroid = /Android/.test(userAgentString);
    // if (isiPhone) {
    //   console.log('iPhone detected.');
    // } else if (isAndroid) {
    //   console.log('Android detected.');
    // } else {
    //   console.log('is DeskTop.');
    //return isiPhone;
    //}
  }

  function LoaderItem() {
    const { progress } = useProgress();
    setLoaded(true);
    if (progress == 100) {
      var newPos = new THREE.Vector3(0, -0.4, 0);
      newPos = new THREE.Vector3(0, -1, 0);
      if (pid == mahindraHardCode || pid == RTR310HardCode || pid == RR310){
        newPos = new THREE.Vector3(0, -1, 0); //0.8
      }
        //console.log(newPos);
      gltf.scene.position.set(newPos.x, newPos.y, newPos.z);
      // console.log(gltf.scene.position);
      // console.log(pid);
      if (progCount < 101) progCount += 25;
      isModelLoaded = true;
      //resetModel();
    }
    return (
      <>
        <Html center>
          <Loader />
          {/* <ProgressBar valuePercentage={progCount} /> */}
          {/* {progText}  */}
        </Html>
      </>
    );
  }

  function resetAnimation() {
    if (gltf.animations.length > 0) {
      for (var i = 0; i < gltf.animations.length; i++)
        PlayAnim(enum_AnimStaus.Reverse, i);
    }
  }

  function resetModel() {
  
  
    // Set preset
    setMeshPreset();

    // Set 0th index color id as selected
    const curConfig = selectedConfigs;
    if(selectedConfigs.length > 0)
      curConfig.pop();
    curConfig.push(curLayoutData.color[0]?.id);
    setSelectedConfig(curConfig);

    onSwapColorMesh(0, true); //If 0, will load default color
  }

  function createHotspotRings() {
    let curMeshPoints = [];
    //console.log("meshesHotspot " , meshesHotspot);
    meshesHotspot?.forEach((hotspot) => {
      if (hotspot.visibility.length > 0) {
        // console.log("hotspot " , hotspot.visibility);
        // console.log("selectedConfig " , selectedConfigs.length);
        for (let i = 0; i < hotspot.visibility.length; i++)
          for (let j = 0; j < selectedConfigs.length; j++){
            //console.log("createHotspotRings for ", hotspot.visibility[i].criteriaId , " vs " , selectedConfigs[j]);
          if (hotspot.visibility[i].criteriaId == selectedConfigs[j]) {
            
            positionHotspot(hotspot);
          }
        }
      } else positionHotspot(hotspot);
           
    });

    function positionHotspot(hotspot) {
      //console.log("createHotspotRings is ", hotspot);
      const id = hotspot?.ID;
      const { x, y, z } = hotspot.Position;

      curMeshPoints.push({
        userData: { id, type: "hotspot" },
        positionList: [x, y, z],
        visibility: hotspot.visibility,
      });
    }
    //console.log("createHotspotRings Count ", curMeshPoints.length);
    setMeshPoints(curMeshPoints);
    if (pid == mahindraHardCode) setMeshVisibility(true);
  }

  function generateMeshPoints({ userData, positionList, visibility }) {
    let innerRing;
    let outerRing;
    let innerX,
      inner_default = 0.01,
      innerX2 = 0.015,
      innerX3 = 0.02;

    let outerX,
      outer_default = 0.01,
      outerX2 = 0.04,
      outerX3 = 0.03;

    if (pid == RTR310HardCode || pid == RTR310Launch || pid == RR310) {
      innerX = innerX3;
      outerX = outerX3;
      innerRing = "grey";
      outerRing = "white";
    } else {
      innerX = inner_default;
      outerX = outer_default;
      innerRing = "#dc143c";
      outerRing = "grey";
    }
    return (
      <>
        <mesh
          visible={meshVisibility}
          userData={userData}
          position={positionList}
          rotation={[0, 0, 0]}
          onClick={(e) => handleHotspotClick(userData?.id, e)}
        >
          <ringGeometry args={[outerX, 0.02, 20]} />
          <meshStandardMaterial color={outerRing} side={THREE.DoubleSide} />
        </mesh>
        <mesh
          visible={meshVisibility}
          userData={userData}
          position={positionList}
          rotation={[0, 0, 0]}
          onClick={(e) => handleHotspotClick(userData?.id, e)}
        >
          <sphereGeometry args={[innerX, 10]} />
          <meshStandardMaterial color={innerRing} side={THREE.DoubleSide} />
        </mesh>
        <mesh
          visible={meshVisibility}
          userData={userData}
          position={positionList}
          rotation={[0, 0, 0]}
          onClick={(e) => handleHotspotClick(userData?.id, e)}
        >
          <ringGeometry args={[0.03, 0.06, 20]} />
          <meshStandardMaterial
            color={innerRing}
            side={THREE.DoubleSide}
            transparent={true}
            opacity={0.01}
          />
        </mesh>
      </>
    );
  }

  function handleHotspotClick(id, event) {
    //console.log("Hotspot Clicked!! ", id, event);
    if (event.detail == 1) {
      dispatch(setHotspotClick(id));
      onHotspotSelection(true, id);
    }
    // document.getElementById("hotspot-icon").style.display = "none";
    // document.getElementById("color-icon").style.display = "none";
  }

  useEffect(() => {
    //Model status
    const status = true;
    dispatch(setDefaultModel(status));
  }, []);

  function onHotspotSelection(status, id = null) {
    if (status) {
      if (ghostedMeshes.length == 0) {
        // Prevent mulitple hotspot calls
        setMeshVisibility(false);
        const selectedHotspot = meshesHotspot.find(
          (hotspot) => hotspot?.ID == id
        );
        // console.log("selectedHotspot ");
        // console.log(selectedHotspot);
        if (gltf != null) {
          var material = new THREE.MeshBasicMaterial({
            color: 0x212121,
            transparent: true,
            opacity: 0.05,
          });
          gltf.scene.traverse(function (node) {
            if (node instanceof THREE.Mesh) {
              if (
                !selectedHotspot?.Mesh.includes(node.name) &&
                !selectedHotspot?.Mesh.includes(node.parent.name)
              ) {
                // console.log(
                //   node.name,
                //   "vs",
                //   selectedHotspot?.Name,
                //   " with ",
                //   selectedHotspot?.Mesh[0]
                // );
                ghostedMeshes.push({ mesh: node, material: node.material });
                node.material = material;
              }
            }
          });
          //console.log("ghostedMeshes pack ", ghostedMeshes.length, " ", id);
        }
      }
    } else {
      setMeshVisibility(true); // Activates the hotspot rings
      //console.log("ghostedMeshes unpack " , ghostedMeshes[10].mesh.name ,ghostedMeshes[10].material.name, ghostedMeshes[10].material.transparent);
      ghostedMeshes?.forEach((ghostedMesh) => {
        ghostedMesh.mesh.material = ghostedMesh.material;
      });
      //console.log("ghostedMeshes unpack " ,ghostedMeshes[10].mesh.name ,ghostedMeshes[10].material.name, ghostedMeshes[10].mesh.material.transparent);
      ghostedMeshes = [];
    }
  }

  function onSwapColorMesh(colorID, isreset = false) {
    if (curLayoutData.color.length == 0) return;
    if (isreset) {
      colorID = curLayoutData.color[colorID]?.id;
    }
    //console.log("onSwapColorMesh is " , colorID );
    if (gltf != null) {
      gltf.scene.traverse(function (node) {
        if (node instanceof THREE.Mesh) {
          loop1: for (let i = 0; i < curLayoutData?.color.length; i++)
            if (curLayoutData.color[i]?.id == colorID) {
              //console.log("Preset " , meshesColor.color[i])
              // 1. Activate Preset Mesh
              setPresetMesh(node, curLayoutData.color[i].preset);
              // 2. Apply Tex on Mesh
              for (let k = 0; k < curLayoutData.color[i].meshes.length; k++)
                if (
                  node.name.toLowerCase() ==
                    curLayoutData.color[i].meshes[k].toLowerCase() ||
                  node.parent.name.toLowerCase() ==
                    curLayoutData.color[i].meshes[k].toLowerCase()
                ) {
                  applyMapTexture(node, curLayoutData.color[i]);
                }
            }
        }
      });
    }
    createHotspotRings();
  }

  function applyMapTexture(node, item) {
    const textureloader = new THREE.TextureLoader();

    // 1. Tex
    textureloader.load(BaseUrl() + pid + "/" + item.maps[0], function (tex) {
      //console.log("Applied Tex ", node.name , " for " ,tex.name);
      tex.flipY = false;
      tex.encoding = THREE.sRGBEncoding;
      node.material.map = tex;
    });
    if (item.maps.length > 1) {
      // 2. Rough Map
      textureloader.load(BaseUrl() + pid + "/" + item.maps[1], function (tex) {
        tex.flipY = false;
        tex.encoding = THREE.sRGBEncoding;
        //tex.colorSpace = THREE.SRGBColorSpace
        node.material.roughnessMap = tex;
      });
    }
  }

  function setPresetMesh(node, preset) {
    for (let i = 0; i < preset?.meshesActive?.length; i++)
      if (preset.meshesActive[i].toLowerCase() == node.name.toLowerCase()) {
        //console.log(preset.meshesActive);
        node.visible = true;
      }

    for (let i = 0; i < preset?.meshesInactive?.length; i++)
      if (preset.meshesInactive[i].toLowerCase() == node.name.toLowerCase())
        node.visible = false;
  }

  function onSwapConfigMesh(dispatchData) {
    // console.log("onSwapConfigMesh Dispatch Len ", dispatchData.length);
    // console.log("onSwapConfigMesh Dispatch Data ", dispatchData);

    if (dispatchData.length != undefined) {
      if (dispatchData.length > 0) {
        // 4. Check Accessories
        var accConfigData = meshesConfig?.accessories;
        for (let j = 0; j < accConfigData?.length; j++) {
          //console.log("Check Accessories 1 : ", accConfigData[j]);
          for (let k = 0; k < dispatchData?.length; k++)
            if (accConfigData[j]?.partNumber == dispatchData[k]?.id) {
              //console.log("Check Accessories 2 : ", accConfigData[j]);
              handleConfigMeshes(accConfigData[j], dispatchData[k]?.status);
            }
        }
      }
    } else {
      // 1. Net Kit Reset - Always Reset First
      if (dispatchData.kitResetStatus) resetModel();

      // 2. Check Color
      kitConfigData = meshesConfig?.color;
      for (let i = 0; i < kitConfigData?.length; i++) {
        if (kitConfigData[i]?.id == dispatchData?.id) {
          curLayoutData = meshesConfig;
          onSwapColorMesh(kitConfigData[i]?.id);
        }
      }

      // 3. Check Kit
      let isKitSelected = false;
      var kitConfigData = meshesConfig?.kits;
      for (let i = 0; i < kitConfigData?.length; i++) {
        if (kitConfigData[i]?.id == dispatchData?.id) {
          isKitSelected = true;
          handleConfigMeshes(kitConfigData[i], dispatchData.status);
          const curConfig = selectedConfigs;
          if (dispatchData.status) curConfig.push(dispatchData?.id);
          else {
            const index = curConfig.indexOf(dispatchData?.id);
            if (index > -1) {
              // only splice array when item is found
              curConfig.splice(index, 1); // 2nd parameter means remove one item only
            }
          }   
          console.log( selectedConfigs);
          setSelectedConfig(curConfig);
        }
      }
      if (isKitSelected) {
        userSelectedKitId = dispatchData?.id;
        createHotspotRings(dispatchData.status); // Recreate hotspot rings as rings can change based on config
      }

      //console.log("onSwapConfigMesh selectedConfigs " , selectedConfigs)
    }

    function handleConfigMeshes(configData, isSwapStatus = true) {
      if (gltf != null)
        gltf.scene.traverse(function (node) {
          if (node instanceof THREE.Mesh) {
            //console.log(  configData.meshes);

            loop1: for (
              let k = 0;
              k < configData.meshes.meshesInactive.length;
              k++
            )
              if (
                node.name.toLowerCase() ==
                configData.meshes.meshesInactive[k].toLowerCase()
              ) {
                // The current selected Config
                //console.log( node.name, isSwapStatus);
                node.visible = !isSwapStatus;
                break loop1;
              }

            loop1: for (
              let k = 0;
              k < configData.meshes.meshesActive.length;
              k++
            )
              if (
                node.name.toLowerCase() ==
                configData.meshes.meshesActive[k].toLowerCase()
              ) {
                // The current selected Config
                //console.log( node.name, isSwapStatus);
                node.visible = isSwapStatus;
                break loop1;
              }
          }
        });
    }
  }

  function SetScene() {
    const { scene, camera } = useThree();

    [skyboxTex] = useTexture([skyboxUrl]);
    if (pid == mahindraHardCode) {
      const color = new THREE.Color("rgb(255, 255, 255)");
      scene.background = color;
      scene.rotation.set(0, 0.2, 0);
      //console.log(gltf.scene.position);
    } else {
      scene.background = skyboxTex;
      scene.rotation.set(0, 2.4, 0);
      scene.position.set(0, 0.2, 0);
    }

    if (!executeOnce) {
      executeOnce = true;
      let curPos = camera.position;
      if (pid == mahindraHardCode) {
        camera.position.set(curPos.x, curPos.y, 7);
      } else camera.position.set(curPos.x, curPos.y, 2);
    }

    useFrame((state, delta) => {
      mixer?.update(delta);
    });

    if (isAutoRotate) scene.rotation.y += 0.005;
  }

  function PlayAnim(animStaus, index) {
    //console.log(animStaus + " clips " + gltf.animations.length + " : " + index);

    let action;
    if (gltf.animations.length > 0) {
      mixer = new THREE.AnimationMixer(gltf.scene);
      action = mixer.clipAction(gltf.animations[index]);

      if (animStaus.Reverse) {
        action.loop(THREE.LoopPingPong);
        action.play();
      } else {
        if (enum_AnimStaus.Play == animStaus) action.play();
        else action.stop();
      }
    }
  }

  function ShadowPlane() {
    const [shadowTex] = useTexture([shadowUrl]);

    var shadowHeight = -1;
    if (pid == RTR310HardCode || pid == RTR310Launch || pid == RR310)
    {
      return (
        // The mesh is at the origin
        // Since it is inside a group, it is at the origin
        // of that group
        // It's rotated by 90 degrees along the X-axis
        // This is because, by default, planes are rendered
        // in the X-Y plane, where Y is the up direction

        <mesh
          position={[0, shadowHeight, 0]}
          rotation={[-Math.PI / 2, 0, 0]}
          scale={[2.5, 0.5, 1]}
        >
          {/*
            The thing that gives the mesh its shape
            In this case the shape is a flat plane
          */}
          <planeBufferGeometry />
          {/*
            The material gives a mesh its texture or look.
            In this case, it is just a uniform green
          */}
          <meshBasicMaterial
            color="white"
            transparent={true}
            opacity={0.25}
            map={shadowTex}
          />
        </mesh>
      );
    }
    else return null;
  }

  function setMeshPreset() {
    if (curLayoutData?.preset?.meshesInactive?.length > 0) {
      for (let i = 0; i < curLayoutData.preset.meshesInactive.length; i++) {
        //console.log("Reset  ", meshesColor.preset.meshesInactive[i])
        HandleMeshVisibility(
          curLayoutData.preset.meshesInactive[i].toLowerCase()
        );
      }
    }
  }

  //******************************************

  function HandleMeshVisibility(meshname, status = false) {
    if (gltf != null)
      gltf.scene.traverse(function (node) {
        if (node instanceof THREE.Mesh) {
          if (node.name.toLowerCase() == meshname) node.visible = status;
        }
      });
  }

  function HandleRaceNumber(selectedRaceNumber) {
    let maps1, maps2;
    meshesConfig.raceNumber.forEach((raceNum) => {
      if (raceNum.partNumber == selectedRaceNumber.id1) {
        maps1 = raceNum;
      }
      if (raceNum.partNumber == selectedRaceNumber.id2) {
        maps2 = raceNum;
      }
    });

    if (gltf != null) {
      gltf.scene.traverse(function (node) {
        if (node instanceof THREE.Mesh) {
          if (
            meshesConfig.raceNumber[0].meshes.meshesActive[0].toLowerCase() ==
            node.name.toLowerCase()
          ) {
            node.visible = true;
            applyMapTexture(node, maps2);
          }

          if (
            meshesConfig.raceNumber[0].meshes.meshesActive[1].toLowerCase() ==
            node.name.toLowerCase()
          ) {
            node.visible = true;
            applyMapTexture(node, maps1);
          }
        }
      });
    }
  }

  useEffect(() => {
    // console.log("Dispatch 0.Data - PID >>", pid);
  }, []);

  useEffect(() => {
    // This function call on color change

    if (onColorChange != undefined) {
      //console.log("Dispatch 1.UI Interaction - onColorChange " + onColorChange);

      const curConfig = selectedConfigs;
      if(selectedConfigs.length > 0)
        curConfig.pop();
      curConfig.push(onColorChange);
      setSelectedConfig(curConfig);
      onSwapColorMesh(onColorChange);
    }
    ReactGA.event(
      {
        category: "Colorswap",
        action: "Colorswap click",
        label: "Colorswap",
        value: 1,
      },
      ["tracker1", "tracker2"]
    );
  }, [onColorChange]);

  useEffect(() => {
    // This function call on mesh visibility change
    //console.log("Dispatch 2.UI Interaction - onAnnotation " + onUIAnnotation);
    if (onUIAnnotation != undefined) setMeshVisibility(onUIAnnotation);
    ReactGA.event(
      {
        category: "Hotspot",
        action: "Hotspot click",
        label: "Hotspot",
        value: 2,
      },
      ["tracker1", "tracker2"]
    );
  }, [onUIAnnotation]);

  useEffect(() => {
    //This function call on hotspot close
    // console.log(
    //   "Dispatch 3.UI Interaction -********** hotspotPanelClose********** ",
    //   hotspotPanelClose
    // );
    // console.log(hotspotPanelClose);
    if (hotspotPanelClose != undefined) onHotspotSelection(false);
    dispatch(setHotspotClick(null));
  }, [hotspotPanelClose]);

  useEffect(() => {
    if (customCompId != undefined) {
      // console.log(
      //   "Dispatch 4.UI Interaction -------- CONGIGURATOR ID >>",
      //   customCompId
      // );
      onSwapConfigMesh(customCompId);
    }
  }, [customCompId]);

  useEffect(() => {
    if (reset != undefined) {
      //console.log("Dispatch 5.UI Interaction -------- RESET >>", reset);
      if (isModelLoaded) resetModel();
    }
  }, [reset]);

  useEffect(() => {
    //This function call on meshdata
    //console.log("Dispatch 1. DATA -------- Layout>>", layoutData);
    if (layoutData != undefined) {
      curLayoutData = layoutData[0];
      if (!(curLayoutData.lId.includes("B") && selectedConfigs.length == 0))
        resetModel();
        else if(curLayout != curLayoutData.lId){
          resetModel();
        }
        //console.log("curLayout", curLayout , " vs " , curLayoutData.lId);
        setCurLayout(curLayoutData.lId)
    }
  }, [layoutData]);

  useEffect(() => {
    if (hotspotdata != undefined) {
      meshesHotspot = hotspotdata.HotspotContent;
      createHotspotRings();
      //console.log("Dispatch 2. Data ------------ Hotspot >>", hotspotdata);
    } else {
       meshPoints.length = 0;
      // console.log(
      //   "Dispatch 2. Data ------------ Hotspot >> ",
      //   meshPoints.length
      // );
    }
  }, [hotspotdata]);

  useEffect(() => {
    // console.log(
    //   "Dispatch 3. Data ------ CONGIGURATOR DATA >>",
    //   customConfigData
    // );
    if (customConfigData != undefined) meshesConfig = customConfigData;
    else meshesConfig = null;
    if (isModelLoaded) {
      setMeshVisibility(false);
      //resetModel();
    }
  }, [customConfigData]);

  useEffect(() => {
    if (raceNum != undefined) {
      //console.log("Dispatch 6.UI Interaction ------ CONGIGURATOR Race Number>>>>>", raceNum);
      HandleRaceNumber(raceNum);
    }
  }, [raceNum]);

  useEffect(() => {
    //console.log("layoutMap STAUS>>>>", layoutMap);
    if (layoutMap == undefined) return;
    layoutMap.forEach((element) => {
      if (element.pId == pid) {
        modelUrl = BaseUrl() + tenantBaseUri + element.path;
        //console.log("modelUrl >>>>", modelUrl);
        resetAnimation();
      }
    });
  }, [layoutMap]);

  useEffect(() => {
    //console.log("ANIMATION STAUS>>>>", animation);
    if (animation != undefined) {
      if (animation?.id == 2) PlayAnim(enum_AnimStaus.Play, 0);
      else if (animation?.id == 0) PlayAnim(enum_AnimStaus.Play, 2);
      else PlayAnim(enum_AnimStaus.Play, 1);
    }
  }, [animation]);

  useEffect(() => {
    //console.log("ROTATE STAUS>>>>", rotate);
    if (rotate != undefined) isAutoRotate = rotate;
  }, [rotate]);

  useEffect(() => {
    //console.log("MENU STAUS>>>>", menuStatus);
  }, [menuStatus]);

  return (
    <>
      <div>
        <div className="TabbedPanel" id="sidebar"></div>
        <div className="model-canvas">
          <Canvas>
            <Suspense fallback={<LoaderItem />}>
              <primitive object={gltf.scene} />
              {meshPoints.map((point) => generateMeshPoints(point))}
              <ShadowPlane />
              <OrbitControls
                minDistance={1.4}
                maxDistance={3}
                enablePan={false}
                target={modelTarget}
              />
              <SetScene />
              <Environment
                files={hdrUrl}
                background={false}
                near={1}
                far={1000}
                resolution={256}
              />
            </Suspense>
          </Canvas>
        </div>
      </div>
    </>
  );
});

export default Model;
